import { HTTPRequest } from "../../Base/Comunication/HTTPRequest";
// pokud přibude víc podobných tříd, tak hodit do samostatného projektu
/**
 * Třída pro přehrávání audio vzorků
 */
export class AudioSample {
    /**
     * Metoda načte audio data ze zadané URL, dekóduje je a vytvoří instanci třídy AudioSample
     * @param url Adresa dotazu
     */
    public static loadAudioSample(url: string): Promise<AudioSample> {
        return HTTPRequest.get(url, "arraybuffer").then((audioData) => AudioSample.decodeAudio(audioData), (e) => {
            throw new Error(`Unable to load audio data. ${e.message}.`);
        }).then((decodedAudioData) => new AudioSample(decodedAudioData));
    }

    /**
     * Metoda pro dekódování audio dat, např. z MP3
     * @param url audio data v podporovaném formátu, např. MP3
     */
    public static decodeAudio(audioData: ArrayBuffer): Promise<AudioBuffer> {
        //return (<any>AudioSample._context).decodeAudioData(audioData); //ve vsech aktualnich verzich prohlizecu tohle funguje, krome Safari (10 Preview) :-(
        return new Promise((resolve, reject) => {
            AudioSample._context.decodeAudioData(audioData, (decodedData) => resolve(decodedData), () => reject(new Error("Unable to decode audio data.")));
        });
    }

    private static __context: AudioContext;

    private static get _context(): AudioContext {
        if (!AudioSample.__context) {
            const audioContext: new() => AudioContext = (self as any).AudioContext || (self as any).webkitAudioContext;
            AudioSample.__context = new audioContext();
        }
        return AudioSample.__context;
    }

    //----------------------------------------------------------------------------------------------------------------

    constructor(private decodedAudioData: AudioBuffer) {
    }

    /**
     * přehraje vzorek
     */
    public play(): void {
        const context = AudioSample._context;
        const s = context.createBufferSource();
        s.buffer = this.decodedAudioData;
        s.connect(context.destination);
        s.start();
    }
}
